import React, { useState } from 'react';
import { Popover } from "flowbite-react";
import { useUtils } from '../../hooks/useUtils';

type NamePopOverTypePrps = {
    memberData: any
}

const NamePopOver = ({memberData} : NamePopOverTypePrps) => {
    const helperUtils = useUtils();    

    if (memberData.is_primary) {
        return (
          <Popover content={ <div className="w-max max-w-[311px] rounded bg-white drop-shadow-5 dark:bg-meta-4">      
          <div className="border-b border-stroke p-3 dark:border-strokedark">
            <h4 className="text-center text-title-sm font-semibold text-black dark:text-white">
              {memberData.name}
            </h4>
          </div>
          <div className="px-5 py-4.5">
            <p className="font-medium">
              <div>Total Requests: <span className="text-blue-400">{memberData.totalRequest}</span></div>
              <div>Total Costs: <span className="text-blue-400">{helperUtils.convertToMoney(parseFloat(memberData.totalCosts))}</span></div>
            </p>
          </div>
        </div>} trigger="hover"><div className="text-orange-500">* {memberData.name}</div></Popover>
        )
      } else {
        return <div>{memberData.name}</div>
      }
}

export default NamePopOver;